import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Button } from 'react-native-paper';
import type { EdgeInsets } from 'react-native-safe-area-context';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

type Props = {
  step: number;
  isStepValid: boolean;
  onNextPress: () => void;
  onSavePress: () => void;
  isSubmitting: boolean;
  emailGateOk: boolean;
};

const makeStyles = (insets: EdgeInsets) =>
  StyleSheet.create({
    footer: {
      marginTop: 'auto',
      paddingBottom: 8 + insets.bottom,
      paddingTop: 8
    }
  });

export const OrganizationCreateFooter: FC<Props> = ({
  step,
  isStepValid,
  onNextPress,
  onSavePress,
  isSubmitting,
  emailGateOk
}) => {
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'screens.organization-create'
  });
  const isLastStep = step === 1;
  const insets = useSafeAreaInsets();
  const styles = useMemo(() => makeStyles(insets), [insets]);

  return (
    <View style={styles.footer}>
      {isLastStep ? (
        <Button
          mode="contained"
          onPress={onSavePress}
          loading={isSubmitting}
          disabled={isSubmitting || !isStepValid || !emailGateOk}
        >
          {t('actions.save')}
        </Button>
      ) : (
        <Button mode="contained" onPress={onNextPress} disabled={!isStepValid}>
          {t('actions.next')}
        </Button>
      )}
    </View>
  );
};
